// Валидаторы и ошибки со стороны сервера
const rules = {
  required: value => !!value || "Обязательное поле",
  length: ({ min, max }) => value =>
    (value &&
      value.length !== "undefined" &&
      (!min || value.length > min) &&
      (!max || value.length < max)) ||
    `Значение должно быть длинее ${min} и короче ${max}`,
  integer: ({ min, max }) => value => {
    console.log("vi", value, !!value, typeof value);
    return (
      !value ||
      (parseInt(value).toString() ==
        value.toString().replace(/^0+(?=\d)/, "") &&
        (!min || parseInt(value) >= min) &&
        (!max || parseInt(value) <= max)) ||
      "Значение должно быть целым числом" +
        (min ? ` от ${min}` : "") +
        (max ? ` до ${max}` : "")
    );
  },
  regexp: ({ expr, message }) => value => {
    console.log(RegExp(expr), new RegExp(expr).test(value));
    return (value && new RegExp(expr).test(value)) || message;
  }
};

export default {
  data() {
    return {
      showErrors: true
    };
  },
  computed: {
    errors: {
      get() {
        if (this.showErrors) return this.$parent.errors[this.field.name];
        else return [];
      },
      set(value) {
        this.$parent.errors[this.field.name] = value;
      }
    }
  },
  methods: {
    onChange() {
      this.showErrors = false;
      // TODO: Необходимо установить в true, при нажатии на сабмит
    },
    validators() {
      console.log("StringField.validators");
      if (!this.field.validators) return [];

      let validators = [];
      for (let [validator, options] of Object.entries(this.field.validators)) {
        if (validator === "required") validators.push(rules[validator]);
        if (validator === "length") {
          validators.push(
            rules[validator]({ min: options.min, max: options.max })
          );
        }
        if (validator === "integer") {
          validators.push(
            rules[validator]({ min: options.min, max: options.max })
          );
        }
        if (validator === "regexp") {
          validators.push(
            rules[validator]({ expr: options.expr, message: options.message })
          );
        }
      }
      return validators;
    }
  }
};
